import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from '../defaultIconStyles.css';

export default function IconRouble({
    width = 20,
    height = 20,
    className,
    ...rest
}: IconProps) {
    return (
        <svg
            fillRule="evenodd"
            viewBox="0 0 16 16"
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <title>Icon billing</title>
            <path
                className={css.colored}
                d="M 9.5 1 C 11.984 1 14 3.016 14 5.5 C 14 7.984 11.984 10 9.5 10 L 6 10 L 6 11 L 10.049 11 C 10.601 11 11.049 11.448 11.049 12 C 11.049 12.552 10.601 13 10.049 13 L 6 13 L 6 14 C 6 14.552 5.552 15 5 15 C 4.448 15 4 14.552 4 14 L 4 13 L 3 13 C 2.448 13 2 12.552 2 12 C 2 11.448 2.448 11 3 11 L 4 11 L 4 10 L 3 10 C 2.448 10 2 9.552 2 9 C 2 8.448 2.448 8 3 8 L 4 8 L 4 2 C 4 1.448 4.448 1 5 1 L 9.5 1 Z  M 9.5 3 L 6 3 L 6 8 L 9.5 8 C 10.88 8 12 6.88 12 5.5 C 12 4.12 10.88 3 9.5 3 Z"
            />
        </svg>
    );
}
